import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import Chart from "react-google-charts";
import { getUserLogins } from "../../../store/actions/reports/reportsActions";

class UserLogins extends Component {
  componentDidMount() {
    //MAJOR ERROR FIX BACKEND FIRST
    this.props.getUserLogins({month: 1});
  }

  getUserLoginData = () => {
    const userLogins = this.props.reports?.userLogins || [];

    return [
      ["x", "User Logins"],
      ...userLogins
        .filter((login) => login.login_date)
        .sort((a, b) => a.login_date > b.login_date)
        .map((login) => [login.login_date, login.count || 0]),
    ];
  };

  render() {
    const userLogins = this.getUserLoginData();

    const monthYear = new Date().toLocaleString("en-us", {
      month: "short",
      year: "numeric",
    });

    return userLogins.length ? (
      <div>
        <div style={{ textAlign: "center", fontSize: 20, fontWeight: "bold" }}>
          User Logins for {monthYear}
        </div>
        <Chart
          width={"100%"}
          height={"600px"}
          chartType="ColumnChart"
          loader={<Spinner animation="border" size="sm" />}
          data={userLogins}
          options={{
            hAxis: {
              title: "Date",
            },
            vAxis: {
              title: "Logins",
              format: "0",
            },
            isStacked: true,
          }}
        />
      </div>
    ) : (
      <Spinner animation="border" size="sm" />
    );
  }
}

const mapStateToProps = (state) => ({
  reports: state.reports,
});
const mapDispatchToProps = (dispatch) => ({
  getUserLogins: (...args) => dispatch(getUserLogins(...args)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserLogins)
);
